/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scanning_AirwavesInputs */

const en_scanning_airwaves = /** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning airwaves...`)
};

const id_scanning_airwaves = /** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memindai gelombang udara...`)
};

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const es_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const fr_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const de_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const ja_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const zh_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const ar_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const it_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const ru_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const pt_scanning_airwaves = en_scanning_airwaves;

/** @type {(inputs: Scanning_AirwavesInputs) => LocalizedString} */
const ko_scanning_airwaves = en_scanning_airwaves;

/**
* | output |
* | --- |
* | "Scanning airwaves..." |
*
* @param {Scanning_AirwavesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const scanning_airwaves = /** @type {((inputs?: Scanning_AirwavesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scanning_AirwavesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scanning_airwaves(inputs)
	if (locale === "es") return es_scanning_airwaves(inputs)
	if (locale === "fr") return fr_scanning_airwaves(inputs)
	if (locale === "de") return de_scanning_airwaves(inputs)
	if (locale === "ja") return ja_scanning_airwaves(inputs)
	if (locale === "zh") return zh_scanning_airwaves(inputs)
	if (locale === "ar") return ar_scanning_airwaves(inputs)
	if (locale === "id") return id_scanning_airwaves(inputs)
	if (locale === "it") return it_scanning_airwaves(inputs)
	if (locale === "ru") return ru_scanning_airwaves(inputs)
	if (locale === "pt") return pt_scanning_airwaves(inputs)
	return ko_scanning_airwaves(inputs)
});